module.exports = __webpack_public_path__ + "static/media/cp-new-post.279f3f60.png";